export const CaricaCode = {
    PRESIDENTE: '028',
    SINDACO: '073',
} as const;
